



















import { Component, Prop, Vue } from 'vue-property-decorator'
import { Route } from 'vue-router'
import { namespace } from 'vuex-class'
const referrals = namespace('referrals')

@Component
export default class LeadsCrumb extends Vue {
    @Prop() readonly route!: Route
    @Prop() readonly last!: boolean
    @referrals.Getter activeView: string
    @referrals.Getter activeDirection: string

    get componentClasses(): object {
        return {
            'crumb': true,
            'crumb--last': this.last,
        }
    }

    get view(): string {
        return this.activeView || 'user'
    }

    get direction(): string {
        return this.activeDirection || 'in'
    }
}

